import { produce } from 'immer';

const INIT_STATE = {
  messages: [],
};

export function addErrorMessages(state = INIT_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case 'ADD_ERROR_MESSAGES':
        draft.messages.push(...action.messages || []);
      break;

      case 'CLEAR_FORM_MESSAGES':
        draft.messages = [];
      break;

      default:
        return state;
    }  
  });
}
